var map = {
	"./icons_cat-base.svg": 62,
	"./icons_cat-base_black.svg": 63,
	"./icons_cat-base_colored.svg": 64,
	"./icons_cat-ecolos.svg": 65,
	"./icons_cat-ecolos_black.svg": 66,
	"./icons_cat-ecolos_colored.svg": 67,
	"./icons_cat-frileux.svg": 68,
	"./icons_cat-frileux_black.svg": 69,
	"./icons_cat-frileux_colored.svg": 70,
	"./icons_cat-puristes.svg": 71,
	"./icons_cat-puristes_black.svg": 72,
	"./icons_cat-puristes_colored.svg": 73,
	"./icons_land.svg": 74,
	"./icons_mask.svg": 75,
	"./icons_parcs.svg": 76,
	"./icons_parcs_black.svg": 77,
	"./icons_parcs_colored.svg": 20,
	"./icons_visibility.svg": 78,
	"./icons_visibility_black.svg": 79,
	"./icons_visibility_colored.svg": 21,
	"./icons_water.svg": 80,
	"./icons_water_blue.svg": 81,
	"./icons_windatlas.svg": 82,
	"./icons_windatlas_black.svg": 83,
	"./icons_windatlas_colored.svg": 22,
	"./icons_zones-exclusions.svg": 84,
	"./icons_zones-exclusions_black.svg": 85,
	"./icons_zones-exclusions_colored.svg": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;